import React, { useEffect, useState } from "react";
import { InterviewService } from "../../../services/InterviewService";
import { useInterviewContext } from "../InterviewContext";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import "../../styles/forms.scss";
import Select from "../../../components/Select";

export default function WorkExperienceForm({ work, onChange }) {
  const { errors, setInterview } = useInterviewContext();
  const { t } = useTranslation();

  const [yearsOfExperiences, setyearOfExperience] = useState([]);
  const [seniorityLevels, setSeniorityLevels] = useState([]);

  useEffect(() => {
    InterviewService.getAllYearsExperience().then((data) =>
      setyearOfExperience(data)
    );
  }, []);

  useEffect(() => {
    InterviewService.getAllSeniorityLevels().then((data) =>
      setSeniorityLevels(data)
    );
  }, []);

  const onChangeOptions = ({ target }) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      candidateWorkExperience: {
        ...prevInterview.candidateWorkExperience,
        [`${target.name}`]: Number(target.value)
      }
    }));
  };

  return (
    <section className="form-group mt-4">
      <h1>{t("Work Experience")}</h1>
      <div className="row">
        <div className="form-group col-3">
          <div className="label-wrapper">
            <label htmlFor="professionalExperienceYearsId">
              {t("Years of Experience*")}
            </label>
            {errors.professionalExperienceYearsId && (
              <div className="error-msg">
                {errors.professionalExperienceYearsId}
              </div>
            )}
          </div>
          <Select
            id="ProfessionalExperienceYearsId"
            value={work.professionalExperienceYearsId || null}
            onChange={onChangeOptions}
            name="professionalExperienceYearsId"
            required
            title={t("Selecione um item da lista.")}
          >
            <option key={0} value={0} selected disabled>
              {t("Years of experience...")}
            </option>
            {yearsOfExperiences.map((years, index) => (
              <option key={index} value={years.id}>
                {t(years.description)}
              </option>
            ))}
          </Select>
        </div>
        <div className="form-group col-3">
          <div className="label-wrapper">
            <label htmlFor="seniorityLevelsId">{t("Seniority Level")}</label>
          </div>
          <Select
            id="SeniorityLevelsId"
            value={work.seniorityLevelsId || null}
            onChange={onChangeOptions}
            name="seniorityLevelsId"
            title={t("Selecione um item da lista.")}
          >
            <option value={null} selected>
              {t("Seniority Level...")}
            </option>
            {seniorityLevels.map((seniority, index) => (
              <option key={index} value={seniority.id}>
                {t(seniority.description)}
              </option>
            ))}
          </Select>
        </div>
      </div>
      <div className="form-group">
        <div className="label-wrapper">
          <label htmlFor="projectsExperienceDetails">
            {t("Main Activities*")}
          </label>
          {errors.projectsExperienceDetails && (
            <div className="error-msg">{errors.projectsExperienceDetails}</div>
          )}
        </div>
        <textarea
          id="projectsExperienceDetails"
          rows="6"
          value={work.projectsExperienceDetails}
          onChange={onChange}
          name="projectsExperienceDetails"
          placeholder={t("Describe tasks and responsibilities...")}
        />
      </div>
    </section>
  );
}

WorkExperienceForm.propTypes = {
  work: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};
